import * as React from 'react';
import { SectionPanel } from 'ui';

const AdminPaperTopPanelComponent = (isMain: boolean): React.FunctionComponent<{ title: string }> =>
  ({ title, children }) =>
    <SectionPanel
      className="admin-paper-top-panel"
      componentId="1"
      validation={undefined}
      info={{ text: '' }}
      isMain={isMain}
      label={{ visible: true, text: title }}>
      {children}
    </SectionPanel>;

export const AdminPaperTopPanel = AdminPaperTopPanelComponent(true);
export const AdminPaperSubPanel = AdminPaperTopPanelComponent(false);
